<dw-loading [show]="loading" *ngIf="loading"></dw-loading>

<div *ngIf="!loading" class="eval-section">
    <ng-container *ngFor="let category of questionData.categories" class="category-section">

        <dw-container *ngIf="categoryVisibility[category.EmployeeReviewCategoryId]"
            [options]="containerOptions[category.EmployeeReviewCategoryId]">
            <span header>
                {{category.ReviewCategory}}
            </span>
            <div body>
                <div class="top-message hide-on-print " [hidden]="!category.ReviewCategoryDescriptionHtml">
                    <dw-html-view [ngModel]="category.ReviewCategoryDescriptionHtml"></dw-html-view>
                </div>
                <div class="dw-red"
                    [hidden]="!submitted && formGroup?.errors?.categoryValidationErrors && formGroup.errors?.categoryValidationErrors[category.EmployeeReviewCategoryId]">
                    {{formGroup?.errors?.categoryValidationErrors[category.EmployeeReviewCategoryId]}}
                </div>

                <ng-container *ngFor="let question of category.EmployeeReviewQuestion">
                    <ng-container *ngIf="question.EmployeeReviewQuestionTypeId == 1">
                        <div class="row">
                            <div class="col-md-9 question">
                                <b>{{question.EmployeeReviewQuestionSkillIdDisplay}}:</b> <br>
                                {{ question.Question }}
                            
                            </div>
                            <div class="col-md-3 answer">

                                <p-dropdown [hidden]="formConfig?.readOnly" [id]="id"
                                    [options]="questionData.answerValues" optionLabel="AnswerDisplay" display="chip"
                                    optionValue="EmployeeReviewAnswerValueId" [group]="false" [showClear]="true"
                                    [ngModel]="answerByQuestionId[question.EmployeeReviewQuestionId]?.EmployeeReviewAnswerValueId"
                                    (ngModelChange)="updateAnswer(question, $event)" [style]="{'width':'100%'}"
                                    appendTo="body" placeholder="">

                                    <ng-template let-item pTemplate="item">
                                        <div>
                                            <div class="pull-left">
                                                {{item?.AnswerDisplay}}
                                            </div>
                                        
                                            <i class="fa fa-info-circle pull-right" [hidden]="!item?.AnswerDescription" [title]="item?.AnswerDescription"></i>
                                        </div>
                                    </ng-template> 
                                </p-dropdown>

                                <div class="form-control mt-4" [hidden]="!formConfig?.readOnly">
                                    {{
                                    answerByQuestionId[question.EmployeeReviewQuestionId]?.EmployeeReviewAnswerValueIdDisplay
                                    }}
                                </div>
                            </div>
                        </div>
                        <hr class="hide-on-print">
                    </ng-container>
                    <ng-container *ngIf="question.EmployeeReviewQuestionTypeId == 2 && !question._isDeleted">
                        <div class="row">
                            <div class="col-md-12 question2">
                                <label class="label">
                                    {{ question.Question }}
                                </label>
                            </div>
                            <div class="col-md-12 answer2">
                                <textarea [hidden]="formConfig?.readOnly"
                                    [ngModel]="answerByQuestionId[question.EmployeeReviewQuestionId]?.AnswerValueText"
                                    (ngModelChange)="updateAnswer(question, $event)" class="form-control" rows="3">

                                </textarea>
                                <div class="answer-text" [hidden]="!formConfig?.readOnly">
                                    {{ answerByQuestionId[question.EmployeeReviewQuestionId]?.AnswerValueText }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="category.EmployeeReviewCategoryId == 4">
                    <div dwRow [formGroup]="formGroup">
                        <div dwCol="6" [hidden]="hideRevenueQuestions">
                            <label class="label">Responsible For Revenue</label>
                            <dw-yesno formControlName="ResponsibleForRevenue" [hidden]="formConfig?.readOnly"></dw-yesno>

                            <dw-readonly formControlName="ResponsibleForRevenue" [hidden]="!formConfig?.readOnly" formatType="yesno"></dw-readonly>
                        </div>
                        <div dwCol="6" [hidden]="hideBiddingQuestions">
                            <label class="label">Responsible For Bidding</label>
                            <dw-yesno formControlName="ResponsibleForBidding" [hidden]="formConfig?.readOnly"></dw-yesno>
                            <dw-readonly formControlName="ResponsibleForBidding" [hidden]="!formConfig?.readOnly" formatType="yesno"></dw-readonly>
                        </div>
                    </div>

                </ng-container>
            </div>
        </dw-container>
    </ng-container>
</div>